<template>
  <!-- 新增应收 -->
  <div class="box-wrap">
    <form-text-box
      :column="column"
      :dataList="receivableList"
      :rules="receivableRules"
      :formProps="formProps"
      ref="receivable"
      :model="model"
    ></form-text-box>
  </div>
</template>

<script>
import { searchByCustomerName, searchByCustomerNameSensitive } from '@/api/domain/customers'
import {
  getCollectCustomerList,
  getSourceOrderId,
} from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'
import config from './config'

export default {
  props: {
    column: {
      type: Number,
      default: () => 2,
    },
  },
  data() {
    const {
      receivableList, // 应收配置项
      receivableRules, // 应收规则
    } = config.call(this)
    return {
      // 应收字段
      receivableList,
      receivableRules,
      formProps: {
        labelWidth: '100px',
      },
      model: {
        receivableAmount: '',
        receivableDate: '',
        content: '',
        customerId: '',
        sourceOrderType: '',
        sourceOrderId: '',
        carId: '',
        remarks: '',
        payeeType: '',
      },
      // eslint-disable-next-line vue/no-unused-properties
      style: {
        customerName:
          'width: 60px ;height: 35px ;overflow: hidden ;text-overflow: ellipsis ;white-space: nowrap ;',
        customerTel:
          'color: #8492a6 ;font-size: 13px ;margin: 0 ;padding-left: 10px ;',
        customStyle: 'display:flex;flex-direction: row;',
      },
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    modifiedRemarks(val) {
      this.model.remarks = val
    },
    /** *
     * 选择 carNoChange 车牌号(carId) +
     * 选择 payableType 付款方类型(customerType) +
     * 选择 handleCustomerIdChange 选择付款方(customerId)
     * 才允许将 来源类型(sourceOrderType) 字段改变为编辑态，
     * 选择 sourceOrderTypeChange 来源类型(sourceOrderType) 后，才允许选择 来源单号(sourceOrderId)
     * */

    // 禁止 来源类型(sourceOrderType) 和 来源单号(sourceOrderId)
    disableSourceOrderTypeAndId() {
      const { carId, customerType, customerId, sourceOrderType } = this.model
      if (!carId || !customerType || !customerId) {
        this.model.sourceOrderType = ''
        this.setItemData('disabled', 'sourceOrderType', true)
        this.model.sourceOrderId = ''
        this.setItemData('list', 'sourceOrderId', [])
        this.setItemData('disabled', 'sourceOrderId', true)
        return
      }
      // 来源类型 可选
      this.setItemData('disabled', 'sourceOrderType', false)
      if (!sourceOrderType) {
        this.model.sourceOrderId = ''
        this.setItemData('list', 'sourceOrderId', [])
        this.setItemData('disabled', 'sourceOrderId', true)
        return
      }
      // 来源单号 可选 需要 carId-车牌号id  sourceOrderType-来源单类型
      this.getSourceOrderId()
      this.setItemData('disabled', 'sourceOrderId', false)
    },
    //
    // 车牌号变更 判断 customerType / customerId  决定 来源类型
    // eslint-disable-next-line vue/no-unused-properties
    carNoChange(value) {
      this.model.carId = value
      this.model.sourceOrderId = ''
      this.setItemData('list', 'sourceOrderId', [])
      this.disableSourceOrderTypeAndId()
    },
    // 付款方类型变更
    // eslint-disable-next-line vue/no-unused-properties
    async payableType(val) {
      this.model.customerId = ''
      this.model.sourceOrderId = ''
      this.setItemData('list', 'customerId', [])
      this.setItemData('disabled', 'customerId', true)
      if (!val) return
      this.setItemData('disabled', 'customerId', false)
      this.setItemData('remote', 'customerId', true)
      if (val === 1) {
        // 服务商
        this.getCollectCustomerList()
        this.setItemData('remote', 'customerId', false)
      } else {
        const { data = [] } = await searchByCustomerNameSensitive({
          customerState: 1,
          mixedType: 'YES',
          customerName: '',
        })
        this.setItemData('list', 'customerId', data)
      }
      this.disableSourceOrderTypeAndId()
    },

    // handleCustomerIdChange
    // eslint-disable-next-line vue/no-unused-properties
    handleCustomerIdChange() {
      this.disableSourceOrderTypeAndId()
    },
    // 来源类型变更
    // eslint-disable-next-line vue/no-unused-properties
    sourceOrderTypeChange(val) {
      this.model.sourceOrderId = ''
      this.setItemData('list', 'sourceOrderId', [])
      if (!val) {
        this.setItemData('disabled', 'sourceOrderId', true)
      } else {
        this.setItemData('disabled', 'sourceOrderId', false)
        this.getSourceOrderId()
      }
    },

    // 客户列表接口
    // eslint-disable-next-line vue/no-unused-properties
    async getPayCustomerList(query) {
      if (this.model.customerType !== 2) return
      if (query.length < 1) return
      const { data = [] } = await searchByCustomerNameSensitive({
        customerState: 1,
        mixedType: 'YES',
        customerName: query,
      })
      this.setItemData('list', 'customerId', data)
      this.setItemData('disabled', 'customerId', false)
    },
    // 服务商列表接口
    async getCollectCustomerList() {
      const result = []
      // 限制最多返回200条
      const { data } = await getCollectCustomerList({
        pageNum: 1,
        pageSize: 200,
      })
      data &&
        data.items &&
        data.items.forEach((item) => {
          result.push({ customerName: item.name, customerTel: item.contactTel, id: item.id })
        })
      this.setItemData('list', 'customerId', result)
    },

    // 获取来源单号
    async getSourceOrderId() {
      this.model.sourceOrderId = ''
      const { sourceOrderType, carId, customerId, customerType } = this.model
      const _type = {}
      if (customerType === 1) {
        _type.providerId = customerId
      } else {
        _type.customerId = customerId
      }
      // carId-车牌号id  sourceOrderType-来源单类型
      if (!sourceOrderType || !carId || !customerId) return
      const { data } = await getSourceOrderId({ carId, sourceOrderType, ..._type })
      const result = data || []
      this.setItemData('list', 'sourceOrderId', result)
    },

    // 初始化设置数据
    initData() {
      // 设置应付内容下拉选项
      this.setItemData('list', 'content', this.freeTypeList)
      // 设置来源类型下拉选项
      this.setItemData('list', 'sourceOrderType', this.sourceOrderTypeList)
      // 设置付款方类型下拉选项
      this.setItemData('list', 'customerType', this.payerList)
    },

    // 设置数据
    setItemData(elConfigKey, key, data) {
      this.$refs.receivable.setItemData({ elConfigKey, key, data })
    },

    // 表单校验 src/pages/finance/collection/components/CollectionAdd.vue有引用
    // eslint-disable-next-line vue/no-unused-properties
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.receivable.getRefs().validate((validate) => {
          if (validate) {
            resolve(this.model)
          } else {
            reject()
          }
        })
      })
    },
    // 表单重置
    // eslint-disable-next-line vue/no-unused-properties
    formResetFields() {
      this.$refs.receivable && this.$refs.receivable.getRefs().resetFields()
      this.setItemData('list', 'sourceOrderId', [])
      this.setItemData('list', 'carId', [])
      this.setItemData('list', 'customerId', [])
    },
  },
  computed: {
    ...mapState({
      freeTypeList(state) {
        return state.global.freeTypeList.filter((item) => {
          // 应收和应付均需过滤掉“租金退款” 司机应收 支付总金额
          return item.code !== 34 && item.code !== 44 && item.code !== 45
        })
      }, // 收款项
    }),
    // 付款方类型枚举
    payerList() {
      const result = {}
      for (const key in selectOption.customerTypeDict) {
        if (Object.hasOwnProperty.call(selectOption.customerTypeDict, key)) {
          if (Number(key) !== 10) {
            result[key] = selectOption.customerTypeDict[key]
          }
        }
      }
      return this.dictParseList(result)
    },

    // 来源单类型
    sourceOrderTypeList() {
      return this.dictParseList(selectOption.sourceOrderTypeDict)
    },
  },
}
</script>
